import type { IScene } from '@seddi/scene';
import { Scene } from '@seddi/ui-babylon-scene';
import log from 'loglevel';
import { v4 as uuidv4 } from 'uuid';

export const sanitizeGarment = (garment: IScene): void => {
  // Sanitize children.
  for (const child of garment.children) {
    // Sanitize garment geometry component.
    if (child.components.garmentGeometry) {
      const hasGeometry = Scene.hasGeometrySurface(garment);
      if (hasGeometry && !child.components.garmentGeometry.surfaceUrl) {
        log.warn(`Garment ${garment._id} missing surface url`);
        child.components.garmentGeometry.surfaceUrl = child.components.garmentGeometry.surface;
      }
    }

    // Sanitize garment piece.
    if (child.components.garmentPiece) {
      // Sanitize garment piece logos.
      const pieceLogos = child.components.garmentPiece.logos ?? [];
      for (const pieceLogo of pieceLogos) {
        if (!pieceLogo._id) {
          log.warn(`Piece ${child._id} logo missing _id`);
          pieceLogo._id = uuidv4();
        }
      }
    }
  }
};
